import { render, staticRenderFns } from "./PoliciesAndTerms.vue?vue&type=template&id=733ca826&"
import script from "./PoliciesAndTerms.vue?vue&type=script&lang=js&"
export * from "./PoliciesAndTerms.vue?vue&type=script&lang=js&"
import style0 from "./PoliciesAndTerms.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports